import React from "react";
import { cn } from "@/lib/utils";

/**
 * Reusable horizontal filter chips for industries.
 * @param items [{key, label, count?}]
 * @param value selected key ("all" for none)
 * @param onChange (key) => void
 * @param includeAll boolean
 */
export default function IndustryChips({ items = [], value = "all", onChange, includeAll = true, className, testidPrefix = "industry-chip" }) {
  const options = includeAll ? [{ key: "all", label: "All industries" }, ...items] : items;
  return (
    <div className={cn("flex flex-wrap gap-2", className)} data-testid="industry-chips">
      {options.map((it) => {
        const active = it.key === value;
        return (
          <button
            key={it.key}
            onClick={() => onChange?.(it.key)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors",
              active
                ? "bg-primary text-primary-foreground border-primary"
                : "bg-white text-primary border-border hover:border-primary"
            )}
            data-testid={`${testidPrefix}-${it.key}`}
          >
            <span>{it.label}</span>
            {typeof it.count === "number" && (
              <span className={cn("text-[10px] tabular-nums", active ? "opacity-80" : "text-muted-foreground")}>
                {it.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
